import { createContext, useContext } from 'react';

const CardVariantContext = createContext("default");
const CardVariantProvider = CardVariantContext.Provider;
const useCardVariant = () => useContext(CardVariantContext);

export { CardVariantProvider, useCardVariant };
